import { LedgerAdapter } from '@tronweb3/tronwallet-adapter-ledger';
import { WalletConnectAdapter } from '@tronweb3/tronwallet-adapter-walletconnect';
import {TronLinkAdapter, BitKeepAdapter, OkxWalletAdapter, TokenPocketAdapter } from '@tronweb3/tronwallet-adapters';

// Tron API Configuration
export const TRON_API = { 'TRON-PRO-API-KEY': 'd1c8ba15-b0f0-4a7a-820e-e151ec701291' };
export const NETWORK = 'https://api.trongrid.io';
export const WALLET_CONFIG = {
  NETWORK: 'Mainnet',
  PROJECT_ID: '3f930f8e56336b44761655d8a270144c',
};

// Supported Wallet Adapters
export const SUPPORTED_WALLETS = [
  new TronLinkAdapter(),
  new WalletConnectAdapter({ 
    // network: WALLET_CONFIG.NETWORK,
    network: '0x2b6653dc',
    options: {
      relayUrl: 'wss://relay.walletconnect.com',
      projectId: WALLET_CONFIG.PROJECT_ID,
      metadata: {
        name: 'Wallet Checker',
        description: 'Tron DApp',
        url: window.location.origin,
        icons: [`${window.location.origin}/favicon.ico`],
      },
    },
    web3ModalConfig: {
      themeMode: 'dark',
      themeVariables: {
        '--wcm-z-index': '6000',
      },
      explorerRecommendedWalletIds: [
        "0b415a746fb9ee99cce155c2ceca0c6f6061b1dbca2d722b3ba16381d0562150", // SafePal wallet
        "4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0", // Trust wallet
        "ef333840daf915aafdc4a004525502d6d49d77bd9c65e0642dbaefb3c2893bef", // imToken wallet
        "20459438007b75f4f4acb98bf29aa3b800550309646d375da5fd4aac6c2a2c66", // TokenPocket wallet
        "38f5d18bd8522c244bdd70cb4a68e0e718865155811c043f052fb9f1c51de662", // Bitget wallet
        // "971e689d0a5be527bac79629b4ee9b925e82208e5168b733496a09c0faed0709", // OKX wallet
      ],
    },
  }),
  new BitKeepAdapter(),
  new TokenPocketAdapter(),
  new OkxWalletAdapter(),
  new LedgerAdapter({
    accountNumber: 2,
  }),
];